module.exports = __webpack_public_path__ + "img/uzh_logo_e_pos.e532ecd0.svg";